module.exports = __webpack_public_path__ + "static/img_1.2cd13a3d.jpg";